import { useLazyQuery } from '@apollo/client';
import { GET_PARK_ZONES_BY_DISTANCE } from 'graphql/queries/getParkZonesByDistance';
import {
  Query,
  QueryParkZonesByDistanceArgs,
} from 'types/generatedSchemaTypes';

const useParkZonesByDistance = () => {
  const [getParkZones, parkZones] = useLazyQuery<
    Query,
    QueryParkZonesByDistanceArgs
  >(GET_PARK_ZONES_BY_DISTANCE, {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  return {
    getParkZones,
    parkZones,
  };
};

export default useParkZonesByDistance;
